<template>
    <div class="row">
        <!-- main title -->
        <div class="col-12">
            <div class="main__title">
                <h2>افزودن قسمت</h2>
            </div>
        </div>
        <!-- end main title -->

        <div class="col-12" v-if="$route.params.episode_id!=0">
            <div style="display: flex">
                <button
                        @click="$router.push({path:'/episode_sources/'+$route.params.episode_id})"
                        type="button" class="form__btn">منابع</button>
                <button
                        @click="$router.push({path:'/episode_subtitle/'+$route.params.episode_id})"
                        type="button" class="form__btn" >زیرنویس ها</button>
            </div>
        </div>
        <div class="col-12">
            <form action="#" class="form">
                <div class="row">
                    <div class="col-12 col-md-5 form__cover">
                        <div class="row">
                            <div class="col-12 col-sm-6 col-md-12">
                                <div class="form__group">
                                    <ImageSelector label="تصویر "
                                                   v-model:previewImage="file_preview"
                                                   @imagefile="(n) => file = n"
                                    />

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-7 form__content">
                        <div class="row">
                            <div class="col-6">
                                <div class="form__group">
                                    <input v-model="name" type="text" class="form__input" placeholder="عنوان">
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form__group">
                                    <input v-model="seo_title" type="text" class="form__input" placeholder="سئو عنوان">
                                  <SeoProgress :string="seo_title"
                                               :min_perfect="50"
                                               :max_perfect="60" />
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="form__group">
                                    <textarea v-model="summary" id="text" name="text" class="form__textarea"
                                              placeholder="توضیحات"></textarea>
                                </div>
                            </div>



<!--                            <div class="col-12 col-sm-6 col-lg-3">-->
<!--                                <div class="form__group">-->
<!--                                    <input v-model="duration" type="text" class="form__input"-->
<!--                                           placeholder="مدت زمان قسمت">-->
<!--                                </div>-->
<!--                            </div>-->






                        </div>
                    </div>


                    <div class="col-12">
                        <ul class="form__radio">
                            <li>
                                <span>وضعیت:</span>
                            </li>
                            <li>
                                <input :value="0"
                                       @input="event => status = event.target.value"
                                       id="status2" type="radio" name="status" :checked="status == 0">
                                <label for="status2">غیر فعال</label>
                            </li>
                            <li>
                                <input :value="1"
                                       @input="event => status = event.target.value" id="status1"
                                       :checked="status == 1"
                                       type="radio" name="status">
                                <label for="status1">فعال</label>
                            </li>

                            <li>
                                <input :value="2"
                                       :checked="status == 2"
                                       @input="event => status = event.target.value"
                                       id="status3" type="radio" name="status">
                                <label for="status3">بزودی</label>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12" v-if="$route.params.episode_id==0">
                        <div class="form__group">
                            <input v-model="link" type="text" class="form__input" placeholder="لینک ویدئو">
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="row">

                            <div class="col-12">
                                <button v-if="status_form==0" @click="insert_data()" type="button" class="form__btn">ثبت</button>
                                <button v-if="status_form!=0" @click="insert_data()" type="button" class="form__btn">ویرایش</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <!-- end form -->
    </div>
</template>

<script>
    import axios from "axios";
    // import {bus} from '../main';
    import ImageSelector from "@/views/CustomComponent/ImageSelector";
    // import the styles
    import Treeselect from 'vue3-treeselect'
    import 'vue3-treeselect/dist/vue3-treeselect.css'
    import SeoProgress from "@/views/CustomComponent/SeoProgress.vue";

    export default {
        name: 'HelloWorld',
        data() {
            return {
                theme_mode_parent: '',
                mybutton: '',
                file_preview: '',
                file: null,

                name: '',
              seo_title: '',
                summary: '',
                duration: '',
                link: '',

                status: 0,
                pay_type: 1,
                status_form: 0,

            }
        },
        components: {
          SeoProgress,
            ImageSelector,
            Treeselect
        },
        mounted() {

            if (this.$route.params.episode_id != 0) {
                this.status_form = this.$route.params.episode_id
                this.get_data();
            }
        },
        methods: {
            get_data() {

                var self = this;

                var formData = new FormData();
                formData.append('id', this.status_form)
                this.axios.post('get_episode', formData, {}).then(function (response) {

                    var content_data = response.data;
                    self.file_preview = content_data.image
                    self.file_preview_cover = content_data.cover_image


                    self.name = content_data.name
                    self.seo_title = content_data.seo_title
                    self.summary = content_data.summary

                    self.duration = content_data.duration

                    self.status = content_data.view_status
                    self.link = ''
                    // items = content_cats.orders;

                }).catch(function (error) {
                    console.log(error);
                });


            },

            insert_data() {

                var self = this;

                var formData = new FormData();
                var url = ""
                if (this.status_form == 0) {
                    url = "insert_episode";
                } else {
                    url = "edit_episode"
                    formData.append("id", this.status_form)
                }

                formData.append("season_id", this.$route.params.season_id)
                formData.append("name", this.name)

              formData.append("seo_title", this.seo_title)
                formData.append("summary", this.summary)
                formData.append("view_status", this.status)
                formData.append("duration", this.duration)
                formData.append("poster_image", this.file)
                formData.append("link", this.link)


                this.axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data.data;
                    self.$router.go(-1)
                    // items = content_cats.orders;
                    self.$toast.success('ثبت با موفقیت انجام شد');


                }).catch(function (error) {
                    console.log(error);
                    self.$toast.error('خطا در ثبت اطلاعات');

                });


            },
        }
    }
</script>

